<template>
  <section>
    <p class="title is-1">Reporte por usuario</p>
    <b-breadcrumb align="is-left">
      <b-breadcrumb-item tag="router-link" to="/">Inicio</b-breadcrumb-item>
    </b-breadcrumb>

    <busqueda-en-fecha v-if="Object.keys(cliente).length > 0" @seleccionada="onBusquedaEnFecha" />
    <busqueda-cliente @seleccionado="onSeleccionado" />
    <div v-if="ventas.length > 1">
  <b>Total de todos los totales: ${{ totalSum.toLocaleString("es-CO") }}</b>
  <br>
  <b>Total de todos los pagos: ${{ totalPagadosSum.toLocaleString("es-CO") }}</b>
  <br>
  <b>----------------------------------------------------------</b>
  <br>
  <b :class="{ 'text-red': saldo > 0, 'text-green': saldo <= 0 }">
    Saldo en fecha seleccionada: ${{ saldo.toLocaleString("es-CO") }}
  </b>
</div>

    <b-button @click="mostrarPagados" class="dark">
      <span>Ver Abonos /Pagos</span>
    </b-button>
    <mensaje-inicial
      class="mt-2"
      :titulo="'Seleccione un periodo de ventas'"
      :subtitulo="'Aquí aparecerán las ventas registradas'"
      v-if="ventas.length < 1"
    />
    <div class="mt-2" v-if="ventas.length > 0">
      <b-table
        class="box"
        :data="ventas"
        :paginated="isPaginated"
        :per-page="perPage"
        :current-page.sync="currentPage"
        :pagination-simple="isPaginationSimple"
        :pagination-position="paginationPosition"
        :default-sort-direction="defaultSortDirection"
        :pagination-rounded="isPaginationRounded"
        :sort-icon="sortIcon"
        :sort-icon-size="sortIconSize"
        default-sort="user.first_name"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
      >
        <b-table-column
          field="id"
          label="Id Venta"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.id }}
        </b-table-column>

        <b-table-column
          field="fecha"
          label="Fecha"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.fecha }}
        </b-table-column>


        <b-table-column
          field="nombreUsuario"
          label="Usuario"
          sortable
          searchable
          v-slot="props"
        >
          {{ props.row.nombreUsuario }}
        </b-table-column>

        <b-table-column field="pagado" label="Pago" sortable v-slot="props">
          ${{ parseInt(props.row.pagado).toLocaleString("es-CO") }}
        </b-table-column>

        <b-table-column field="Cambio" label="Cambio" sortable v-slot="props">
          ${{
            parseInt(props.row.pagado - props.row.total).toLocaleString("es-CO")
          }}
        </b-table-column>

        <b-table-column field="total" label="Total" sortable v-slot="props">
          <b>${{ parseInt(props.row.total).toLocaleString("es-CO") }}</b>
        </b-table-column>

        <b-table-column
          field="productos"
          label="Productos"
          sortable
          v-slot="props"
        >
          <tabla-productos-vendidos
            :productos="props.row.productos"
            :viene="2,"
          />
        </b-table-column>

        <b-table-column field="ticket" label="Comprobante" v-slot="props">
          <b-button
            type="is-info"
            icon-left="ticket-outline"
            @click="generarComprobante(props.row)"
            >Comprobante</b-button
          >
        </b-table-column>
      </b-table>
    </div>
    <comprobante-compra
      :venta="this.ventaSeleccionada"
      :tipo="'venta'"
      v-if="mostrarComprobante"
      @impreso="onImpreso"
    />
    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
  <script>
import BusquedaEnFecha from "../Extras/BusquedaEnFecha";
import BusquedaCliente from '../Clientes/BusquedaCliente'
import MensajeInicial from "../Extras/MensajeInicial";
import TablaProductosVendidos from "./TablaProductosVendidos";
import ComprobanteCompra from "./ComprobanteCompra";
import HttpService from "../../Servicios/HttpService";
import Swal from "sweetalert2"; // Importar SweetAlert2

export default {
  name: "ReporteVentas",
  components: {
    BusquedaEnFecha,
    TablaProductosVendidos,
    MensajeInicial,
    ComprobanteCompra,
    BusquedaCliente
  },

  data: () => ({
    cliente: {},
    filtros: {
      fechaInicio: "",
      fechaFin: "",
    },
    cargando: false,
    ventas: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "asc",
    sortIcon: "arrow-up",
    sortIconSize: "is-medium",
    currentPage: 1,
    perPage: 5,
    totalesGenerales: [],
    mostrarComprobante: false,
    ventaSeleccionada: null,
    ventascajerofecha: [],
    isExpanded: false,
    transacciones: [],
    totalProductos: [],
    reporte: [],
    fechaInicio: "",
    fechaFin: "",
    pagados: [],

  }),

  mounted() {
    document.title = "Reporte Ventas";
  },

  methods: {
    onSeleccionado(cliente) {
      this.cliente = cliente;
    },
    onImpreso(resultado) {
      this.mostrarComprobante = resultado;
    },
    generarComprobante(venta) {
      this.mostrarComprobante = true;
      this.ventaSeleccionada = venta;
    },
    onBusquedaEnFecha(fechas) {
      // Establecer la fecha de inicio con la hora constante a las 05:00:00 en UTC
      const fechaInicio = new Date(fechas[0]);
      fechaInicio.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaInicioString =
        fechaInicio.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaInicio = fechaInicioString;
      // Establecer la fecha de fin con la hora constante a las 05:00:00 en UTC
      const fechaFin = new Date(fechas[1]);
      fechaFin.setUTCHours(5, 0, 0, 0); // Establecer la hora a las 05:00:00 en UTC
      // Sumar un día a la fecha fin
      fechaFin.setUTCDate(fechaFin.getUTCDate() + 1);
      // Formatear la fecha y hora como cadena "YYYY-MM-DD HH:mm:ss"
      const fechaFinString = fechaFin.toISOString().split("T")[0] + " 05:00:00";
      this.filtros.fechaFin = fechaFinString;
      this.fechaInicio = fechaInicioString;
      this.fechaFin = fechaFinString;
      this.obtenerVentas();
    },
    obtenerTransaciones() {
      let payload = {
        filtros: this.filtros,
        accion: "obtenerTransacciones",
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (transacciones) => {
          this.transacciones = transacciones;
          console.log(this.transacciones);
        }
      );
    },
    obtenerProductos() {
      let payload = {
        filtros: this.filtros,
        accion: "totalProductos",
      };
      HttpService.obtenerConConsultas("vender.php", payload)
        .then((resultado) => {
          this.totalProductos = resultado.totalp;
        })
        .catch((error) => {
          console.error("Error al obtener productos:", error);
        });
    },
    obtenerVentas() {
      this.cargando = true;
      let payload = {
        filtros: this.filtros,
        accion: "obtener_cuentas_cliente",
        cliente: this.cliente
      };
      HttpService.obtenerConConsultas("vender.php", payload).then(
        (resultado) => {
          this.ventas = resultado.ventas;
          this.pagados = resultado.pagados;
          this.cargando = false;
        }
      );
    },
    mostrarPagados() {
      let tableContent = `
        <table border="1" style="width:100%; text-align: left;">
          <thead>
            <tr>
              <th>ID</th>
              <th>Fecha</th>
              <th>Pagado</th>
            </tr>
          </thead>
          <tbody>
      `;

      this.pagados.forEach(item => {
        tableContent += `
          <tr>
            <td>${item.id}</td>
            <td>${item.fecha}</td>
            <td>$${parseInt(item.pagado).toLocaleString("es-CO")}</td>
          </tr>
        `;
      });

      tableContent += `
          </tbody>
        </table>
      `;

      Swal.fire({
        title: 'Pagados',
        html: tableContent,
        width: '80%',
        confirmButtonText: 'Cerrar'
      });
    },

  },
  computed: {
    totalSum() {
      return this.ventas.reduce((sum, venta) => sum + parseInt(venta.total), 0);
    },
    totalPagadosSum() {
      return this.pagados.reduce((sum, pago) => sum + parseInt(pago.pagado), 0);
    },
    saldo() {
    return this.totalSum - this.totalPagadosSum;
  }
  },
};
</script>
  
  <style scoped>
  .text-red {
  color: red;
}
.text-green {
  color: green;
}

.custom-table {
  border-collapse: collapse;
  width: 106%;
}

.custom-table th {
  border: 1px solid black;
  background-color: #f2f2f2;
  color: black;
  padding: 2px;
  text-align: left;
}

.custom-table td {
  border: 1px solid black;
  color: black;
  padding: 2px;
  font-size: 12px; /* Tamaño de fuente reducido */
}
.expand-button {
  cursor: pointer;
  padding: 4px;
  background-color: rgb(20, 19, 19);
  text-align: center;
  width: 20px;
  margin-bottom: 8px;
}

.expand-button span {
  font-weight: bold;
}

.expanded .custom-table {
  display: table;
}

.expanded .expand-button span {
  transform: rotate(-90deg);
}

#pequeño {
  max-width: 400px; /* Ajusta el ancho máximo según tu preferencia */
  margin: left; /* Centra la tarjeta en el contenedor */
  padding: 10px; /* Ajusta el relleno según tu preferencia */
}

#pequeño {
  width: 100%; /* Asegura que la tabla ocupe el 100% del ancho de la tarjeta */
}

.fondo-rojo {
  background-color: #f2a8a8; /* Puedes ajustar el color según tus preferencias */
}

.fondo-verde {
  background-color: #aaf2d8; /* Puedes ajustar el color según tus preferencias */
}
#reporteVentasTable {
  font-size: 14px; /* Tamaño de fuente más grande */
  width: 100%;
  margin-bottom: 1rem;
  background-color: #fff;
  color: #4a4a4a;
  border-collapse: collapse;
  border-spacing: 0;
}

#reporteVentasTable th,
#reporteVentasTable td {
  padding: 1rem; /* Aumentar el padding */
  vertical-align: top;
  border-top: 1px solid #eaeaea;
}

#reporteVentasTable th {
  font-weight: bold;
  background-color: #f9f9f9;
  text-align: center;
}

#reporteVentasTable td {
  text-align: left;
}

#reporteVentasTable tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.swal2-custom {
  width: 90%; /* Ancho personalizado del popup */
  margin-left: auto;
  margin-right: auto; /* Centrado horizontal del popup */
}
.button {
  margin-top: 1rem; /* Espacio adicional arriba del botón */
}
</style>
  
  